<title>Register</title>
<app-banner [banner]="registerPage.banner"></app-banner>

<div class="bagel-register-page">
  <h1 class="page-title">Register</h1>
  <p class="page-subtitle">Create your NDC Portal account</p>

  <ba-message *ngIf="registrationError" variant="error">
    {{ registrationError }}
  </ba-message>

  <form [formGroup]="registerForm" (ngSubmit)="updateUserProfile()" novalidate>

    <!-- Details -->
    <div class="card-section">
      <div class="card-header">
        <h2 class="card-heading">Details</h2>
        <p class="card-subheading">Enter your personal and organisation information</p>
      </div>
      <div class="card-body">
        <ba-input-text
          label="First Name"
          required="true"
          min-length="2"
          max-length="30"
          (baOnInput)="onTextInput($event, 'firstName')">
        </ba-input-text>
        <div class="field-error" *ngIf="submitted && f['firstName'].errors">
          First name must be at least 2 characters long &amp; no longer than 30 characters.
        </div>

        <ba-input-text
          label="Last Name"
          required="true"
          min-length="2"
          max-length="30"
          (baOnInput)="onTextInput($event, 'lastName')">
        </ba-input-text>
        <div class="field-error" *ngIf="submitted && f['lastName'].errors">
          Last name must be at least 2 characters long &amp; no longer than 30 characters.
        </div>

        <ba-input-text
          label="Company Name"
          required="true"
          min-length="1"
          max-length="100"
          (baOnInput)="onTextInput($event, 'companyName')">
        </ba-input-text>
        <div class="field-error" *ngIf="submitted && f['companyName'].errors">
          Company name must be between 1 and 100 characters long.
        </div>

        <div class="form-row">
          <div class="form-col">
            <ba-select label="Agent Type" required="true" [attr.value]="f['agentType'].value" (baChange)="onSelectAgent($event)">
              <option value="IATA">IATA</option>
              <option value="AGGREGATOR">Aggregator</option>
              <option value="TIDS">TIDS</option>
              <option value="CORPORATE">Corporate</option>
              <option value="NON-IATA">Non-IATA</option>
            </ba-select>
          </div>

          <div class="form-col" *ngIf="f['agentType'].value !== 'NON-IATA'">
            <ng-container *ngIf="f['agentType'].value === 'IATA'">
              <ba-input-text
                label="IATA Id"
                required="true"
                max-length="10"
                (baOnInput)="onTextInput($event, 'IATAid')"
                (keypress)="keyPressNumbers($event)">
              </ba-input-text>
              <div class="field-error" *ngIf="submitted && f['IATAid'].errors">
                IATA number must be between 7 and 10 characters long.
              </div>
            </ng-container>

            <ng-container *ngIf="f['agentType'].value === 'AGGREGATOR'">
              <ba-input-text
                label="Aggregator Id"
                required="true"
                max-length="8"
                (baOnInput)="onTextInput($event, 'AggregatorId')"
                (keypress)="keyPressNumbers($event)">
              </ba-input-text>
              <div class="field-error" *ngIf="submitted && f['AggregatorId'].errors">
                Aggregator Id must be 7 or 8 characters long.
              </div>
            </ng-container>

            <ng-container *ngIf="f['agentType'].value === 'TIDS'">
              <ba-input-text
                label="TIDS Id"
                required="true"
                max-length="8"
                (baOnInput)="onTextInput($event, 'TIDSId')">
              </ba-input-text>
              <div class="field-error" *ngIf="submitted && f['TIDSId'].errors">
                TIDS Id must be 7 or 8 characters long.
              </div>
            </ng-container>

            <ng-container *ngIf="f['agentType'].value === 'CORPORATE'">
              <ba-input-text
                label="Corporate Id"
                required="true"
                max-length="10"
                (baOnInput)="onTextInput($event, 'CorporateId')">
              </ba-input-text>
              <div class="field-error" *ngIf="submitted && f['CorporateId'].errors">
                Corporate Id must be between 7 and 10 characters long.
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Mail Preferences -->
    <div class="card-section">
      <div class="card-header">
        <h2 class="card-heading">Mail Preferences</h2>
        <p class="card-subheading">Choose which email notifications you'd like to receive</p>
      </div>
      <div class="card-body">

        <ba-accordion heading="General Communications" [attr.open]="true">
          <div class="checkbox-item">
            <ba-checkbox
              label="NDC Commercial News"
              (baChange)="onCheckboxChange($event, 'NDCCommercialNews')">
            </ba-checkbox>
            <p class="checkbox-description">Commercial announcements, partner news and general updates about BA's NDC programme</p>
          </div>
          <div class="checkbox-item">
            <ba-checkbox
              label="IAG Portal Users"
              (baChange)="onCheckboxChange($event, 'IAGPortalUsers')">
            </ba-checkbox>
            <p class="checkbox-description">Information and announcements for registered IAG portal users</p>
          </div>
        </ba-accordion>

        <ba-accordion heading="Technical Updates" [attr.open]="true">
          <div class="checkbox-item">
            <ba-checkbox
              label="NDC Technical Updates"
              (baChange)="onCheckboxChange($event, 'platformUpdates')">
            </ba-checkbox>
            <p class="checkbox-description">API changes, release notes, technical behaviours and integration updates</p>
          </div>
          <div class="checkbox-item">
            <ba-checkbox
              label="Technical Operational Alerts 17.2"
              (baChange)="onCheckboxChange($event, 'operationalOldAPIUpdates')">
            </ba-checkbox>
            <p class="checkbox-description">Technical Operational Alerts 17.2</p>
            <div class="field-error" *ngIf="submitted && f['operationalOldAPIUpdates'].errors">This field is required.</div>
          </div>
          <div class="checkbox-item">
            <ba-checkbox
              label="Technical Operational Alerts 21.3"
              (baChange)="onCheckboxChange($event, 'operationalNewAPIUpdates')">
            </ba-checkbox>
            <p class="checkbox-description">Technical Operational Alerts 21.3</p>
            <div class="field-error" *ngIf="submitted && f['operationalNewAPIUpdates'].errors">This field is required.</div>
          </div>
        </ba-accordion>


      </div>
    </div>

    <!-- Save Button -->
    <div class="action-bar">
      <ba-button variant="primary" (click)="updateUserProfile()">Save</ba-button>
    </div>

  </form>
</div>
